import type { Intakes } from "gql/api";
import type { EquipmentTableColumn } from "@/composables/equipment/equipmentTypes";

export const hpsIntakeTableColumns: EquipmentTableColumn<Intakes>[] = [
  {
    editable: true,
    field: "include_koc_timestamp",
    header: "Include KOC",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_koc_timestamp",
    header: "KOC Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "include_ecopetrol_timestamp",
    header: "Include Ecopetrol",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_ecopetrol_timestamp",
    header: "Ecopetrol Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "manufacturer",
    header: "Manufacturer",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "part_number",
    header: "Part Number",
    sortable: true,
    adminOnly: true,
    searchable: true
  },
  {
    editable: true,
    field: "intake_type",
    header: "Intake Type",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "outer_diameter_inches",
    header: "Primary OD (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "inner_diameter_inches",
    header: "Inner Diameter (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "neck_outer_diameter_inches",
    header: "Secondary OD (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    adminOnly: true
  },
  {
    editable: true,
    field: "neck_inner_diameter_inches",
    header: "Tertiary OD (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    adminOnly: true
  },
  {
    editable: true,
    field: "length_inches",
    header: "Length (in)",
    isNumber: true,
    adminOnly: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "weight_pounds",
    header: "Weight (lb)",
    isNumber: true,
    adminOnly: true,
    sortable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "shaft_material",
    header: "Shaft Material",
    sortable: true,
    searchable: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "configuration",
    header: "Configuration",
    sortable: true
  },
  {
    editable: true,
    field: "shaft_limit_hp",
    header: "Shaft Limit (HP)",
    isNumber: true,
    sortable: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "high_strength_shaft_limit_hp",
    header: "High Strength Shaft Limit (HP)",
    isNumber: true,
    sortable: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "housing_material",
    header: "Housing Material",
    sortable: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "max_rate_bpd",
    header: "Max Rate",
    isNumber: true,
    sortable: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "hp",
    header: "Horsepower",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "bolt_on",
    header: "Bolt On",
    isDropdown: true,
    sortable: true,
    adminOnly: true,
    searchable: true
  },
  {
    editable: true,
    field: "port_area_square_inches",
    header: "Port Area (sqin)",
    sortable: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "eff1",
    header: "Eff 1",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "eff2",
    header: "Eff 2",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "stage_count",
    header: "Stage Count",
    isNumber: true,
    sortable: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "bhp0",
    header: "bhp0",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 25
  },
  {
    editable: true,
    field: "bhp1",
    header: "bhp1",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 25
  },
  {
    editable: true,
    field: "bhp2",
    header: "bhp2",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 25
  },
  {
    editable: true,
    field: "bhp3",
    header: "bhp3",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 25
  },
  {
    editable: true,
    field: "bhp4",
    header: "bhp4",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 25
  },
  {
    editable: true,
    field: "bhp5",
    header: "bhp5",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 25
  }
];
